import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';

const SelectMultiples = ({setOption, options, isLoading}) => {
    const [isDefault, setIsDefault] = useState(true);
    const [selectedValue, set_SelectedValue] = useState([]);
    const [selectedLabel, set_SelectedLabel] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const toggleLang = (option) => {
        setIsDefault(false);
        if (selectedValue.includes(option?._id)) {
            const newValue = selectedValue.filter((item) => item !== option?._id);
            const newLabel = selectedLabel.filter((item) => item !== option?.name);
            set_SelectedValue(newValue);
            set_SelectedLabel(newLabel);
        } else {
            set_SelectedValue([...selectedValue, option?._id]);
            set_SelectedLabel([...selectedLabel, option?.name]);
        }
    };

    useEffect(() => {
        if(isDefault && !_.isEmpty(options)) {
            setTimeout(() => {}, 1000)
            let _optionsValue = [];
            let _optionsName = [];
            options.map((option) => {
                _optionsValue.push(option?._id);
                _optionsName.push(option?.name);
            });
            setOption((prev) => ({...prev, listName: _optionsName.join(', '), listId: _optionsValue.join(', '), amount: _optionsValue.length}));
        } else {
            setOption((prev) => ({...prev, listName: selectedLabel.join(', '), listId: selectedValue.join(', '), amount: selectedValue.length}));
        }
    }, [selectedValue]);

    useEffect(() => {
            if(isLoading.loadingSummaryMoney || isLoading.loadingSummaryOrder || isLoading.loadingSummaryStock) {
                setDisabled(true);
            } else {
                setDisabled(false);
            }
    }, [isLoading]);

    return (
        <div>
            <Dropdown>
                <Dropdown.Toggle
                    id="dropdown-basic"
                    disabled={disabled}    
                >
                    ເລືອກເພສ
                </Dropdown.Toggle>
                { _.isEmpty(options) ? null : (
                    <Dropdown.Menu>
                        {options.map((option, index) => (
                            <Dropdown.Item
                                key={index}
                                onClick={() => toggleLang(option)}
                                active={selectedValue.includes(option?._id)}
                            >
                                {option?.name}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>)
                }
            </Dropdown>
        </div>
    );
};

export default SelectMultiples;